import React from 'react'
import * as S from './Form.style'

const Form = ({ onSubmit, children }) => {
  return (
    <>
      <S.Form aria-label="form" onSubmit={onSubmit}>
        {children}
      </S.Form>
    </>
  )
}
export { Form }
